// Build constants
export const RUNES_MIN_PICKRATE = 0.01;
export const KEYSTONE_MIN_PICKRATE = 0.03;
export const ITEMS_MIN_PICKRATE = 0.025;
export const ITEMS_MIN_PICKRATE_FALLBACK = 0.002;
export const ITEMS_MIN_CORE_PICKRATE = 0.05;

export const MAX_BUILDS_SHOWN = 4;

// Build titles
export const PRIMARY_INDEX = 2;
export const PRIMARY_ITEM_WEIGHT = 1;
export const SECONDARY_ITEM_WEIGHT = 0.5;
export const PRIMARY_TAG_WEIGHT = 3;
export const SECONDARY_TAG_WEIGHT = 2;

export const STARTERS = {
  1101: "Scorchclaw Pup",
  1102: "Gustwalker Hatchling",
  1103: "Mosstomper Seedling",

  1056: "Doran's Ring",
  1054: "Doran's Shield",
  1055: "Doran's Blade",

  3854: "Steel Shoulderguards",
  3850: "Spellthief's Edge",
  3862: "Spectral Sickle",
  3858: "Relic Shield",

  3865: "World Atlas", // New for 2024, replaces above support items

  2033: "Corrupting Potion",
  3070: "Tear of the Goddess",
  1082: "Dark Seal",
  1083: "Cull",
  1036: "Long Sword",

  // Aram only
  2051: "Guardians horn",
  3112: "Guardians orb",
  3184: "Guardians hammer",
};

export const SUPPORT_ITEMS = {
  3869: 3869, // Celestial opposition
  3870: 3870, // Dreammaker
  3871: 3871, // ZakZak
  3876: 3876, // Solstice sleigh
  3877: 3877, // bloodsong
};

export const POTIONS = {
  2003: "heath",
  2031: "refill",
  2139: "Elixir of Sorcery",
  2138: "Elixir of Iron",
  2140: "Elixir of Wrath",
};
export const POTIONS_IDS = {
  health: 2003,
  refillable: 2031,
  corrupting: 2033,
};

export const STARTERS_IDS = {
  scorchclawPup: 1101,
  gustwalkerHatchling: 1102,
  mosstomperSeedling: 1103,

  // ARAM
  guardiansHorn: 2051,
  guardiansOrb: 3112,
  guardiansHammer: 3184,
};

export const JUNGLE_STARTERS = {
  [STARTERS_IDS.scorchclawPup]: true,
  [STARTERS_IDS.gustwalkerHatchling]: true,
  [STARTERS_IDS.mosstomperSeedling]: true,
};

export const TRINKETS = {
  3340: "Warding",
  3348: "Sweeper",
  3361: "Greater stealth",
  3362: "Greater Vision",
  3363: "farsight",
  3364: "Oracles",
  3330: "Effigy",
};

export const WARDS = {
  2055: "Control Ward",
};

export const UNIQUE_ITEM_PASSIVES = [
  { type: "critModifier", items: [] },
  { type: "manaCharge", items: [3003, 3004, 3042, 3040, 3119, 3121] },
  { type: "lifeline", items: [6673, 3053, 3156, 3155, 3040] },
  { type: "lastWhisper", items: [6694, 3036, 3035, 3033] },
  { type: "quicksilver", items: [6035, 3139] },
  { type: "hydra", items: [3748, 3074, 6698, 6631] },
  { type: "spellblade", items: [3100, 6632, 3078, 6662] },
  { type: "armorpen", items: [6694, 3071, 3036, 3033, 3302] },
  { type: "magicpen", items: [3135, 3137] },
  { type: "immolate", items: [3068, 6664] },
];

export const BOOTS = {
  1001: "basic",
  3158: "Lucidity",
  3006: "Berserkers",
  3009: "Swiftness",
  3020: "Sorcerers",
  3047: "Steelcaps",
  3111: "Mercurys",
  3117: "Mobility",
  2422: "Slightly Magical Footwear",
  3005: "Ghostcrawlers",
  3010: "Symbiotic Soles",
  3013: "Synchronized Souls",
  223005: "Ghostcrawlers Arena",
  223111: "Mercurys Arena",
  223047: "Steelcaps Arena",
  223006: "Berserkers Arena",
  223009: "Swiftness Arena",
  223020: "Sorcerers Arena",
  223158: "Lucidity Arena",
};

export const BOOTS_IDS = {
  basic: 1001,
};

export const TEAR_ITEMS = {
  tear: 3070,
  manamune: 3004,
  muramana: 3043,
  archangels: 3003,
  seraphs: 3040,
  wintersApproach: 3119,
  fimbulwinter: 3121,
};

export const BAD_FILLER_ITEMS = {
  6657: "Rod of Ages",
  3003: TEAR_ITEMS.archangels,
  3040: TEAR_ITEMS.seraphs,
  3119: TEAR_ITEMS.wintersApproach,
  3121: TEAR_ITEMS.fimbulwinter,
  3004: TEAR_ITEMS.manamune,
  3043: TEAR_ITEMS.muramana,
};

// Season 15/2025
export const DEPRECATED_RUNES_MAP_SEASON = "15.1";
export const DEPRECATED_RUNES_MAP = {
  8138: 8140, // Eyeball collection -> Grisly Mementos
  8136: 8137, // Zombie ward -> Sixth Sense
  8120: 8141, // Ghost poro -> Deep ward
};

export const BUILD_FORMAT = {
  key: null,
  games: 0,
  wins: 0,
  winRate: 0,
  runePages: [],
  summonerSpellPages: [],
  items_starting: [],
  items_completed: [],
  items_situational: [],
  items_boots: [],
  items_order: [],
  skills: [],
  stats: {
    runes: {},
    items: {},
    summoners: {},
  },
  misc: {
    playstyleTitle: null,
    metaTags: [],

    // MATCHUPS AND PROBUILDS
    opponentChampion: null,

    // PROBUILDS
    gameId: null,
    player: null,
    patch: null,
    insertedAt: null,
  },
};

export const BUILD_HASH_DEFAULT = {
  index: 0,
  buildKey: "",
  isSkeleton: true,
  build: {
    ...BUILD_FORMAT,
    runes: [8000, null, null, null, null, 8300, null, null, null, null, null],
    rune_shards: [],
    summoner_spells: [null, null],
    items_starting: [null, null],
    items_completed: [null, null, null, null, null, null],
    items_situational: [null, null, null, null, null, null, null, null],
    items_boots: [null, null],
    items_order: [null, null, null, null],
  },
  originalBuild: {
    games: 0,
    wins: 0,
    startingItemsIndex: 0,
    primaryRune: 0,
    coreItems: [],
    runes: [],
    situationalItems: [],
    skillOrders: [],
    startingItems: [],
    summonerSpells: [],
  },
};

export const BUILD_SORT = {
  winrate: "WINRATE",
  common: "COMMON",
  pro: "PRO",
};

export const BUILD_TIERS = {
  standard: "Standard",
  nonStandard: "Pro",
};
